import React, {useState} from 'react';

import MultiStateSpinner from '../../multiStateSpinner/multiStateSpinner';
import ToolTipComponent from '../../toolTipComponent';
import UpgradeComponent from '../upgradeComponent/upgradeComponent';
import VIDABOO_CONSTANTS from '../../../../../config/consts';

import './multiStateButton.css';

const MultiStateButton = ({
  isDeleteBtn = false,
  isGhost = false,
  isDisabled = false,
  isOutlinedBtn = false,
  isPrimaryBtn = false,
  isSelected = false,
  showSpinner = false,
  billingPlanFeature = null,
  btnTxt = '',
  leftImage = null,
  rightImage = null,
  toolTipPosition = 'top',
  toolTipTxt = '',
  stopEventPropagation = false,
  onClick = () => {},
}) => {
  const [showToolTip, setShowToolTip] = useState(false);

  const handleToolTip = () => {
    if (toolTipTxt) {
      setShowToolTip(!showToolTip);
    }
  };

  return (
    <div
      className={`et-v2-multi-state-btn-container ${
        isDisabled || showSpinner ? 'et-v2-multi-state-btn-disabled' : ''
      } ${isPrimaryBtn ? 'et-v2-multi-state-primary-btn' : ''} ${
        isDeleteBtn ? 'et-v2-multi-state-delete-btn' : ''
      } ${isOutlinedBtn ? 'et-v2-multi-state-outlined-btn' : ''}  ${
        isSelected && !isDisabled ? 'et-v2-multi-state-selected-btn' : ''
      } 
  ${isGhost && !isDisabled ? 'et-v2-multi-state-ghost-btn' : ''}`}>
      <UpgradeComponent billingPlanFeature={billingPlanFeature} />
      <div
        className="et-v2-multi-state-btn-content-wrap"
        onMouseEnter={handleToolTip}
        onMouseLeave={handleToolTip}
        onClick={(event) => {
          if (stopEventPropagation) {
            event.stopPropagation();
          }
          if (!isDisabled && !showSpinner) {
            onClick();
          }
        }}>
        {showToolTip && (
          <ToolTipComponent
            toolTipPosition={toolTipPosition}
            toolTipTxt={toolTipTxt}
          />
        )}
        {showSpinner ? (
          <MultiStateSpinner
            spinnerColor={
              isPrimaryBtn || isDeleteBtn
                ? VIDABOO_CONSTANTS.SPINNER_COLOR.WHITE
                : VIDABOO_CONSTANTS.SPINNER_COLOR.BLUE
            }
            spinnerSize={VIDABOO_CONSTANTS.SPINNER_SIZE.SMALL}
          />
        ) : (
          <>
            {leftImage && (
              <div className={`et-v2-multi-state-btn-left-image-wrap`}>
                {leftImage}
              </div>
            )}
            {btnTxt && (
              <div
                className={`et-v2-multi-state-btn-text ${
                  leftImage ? 'et-v2-multi-state-btn-text-with-left-margin' : ''
                } ${
                  rightImage
                    ? 'et-v2-multi-state-btn-text-with-right-margin'
                    : ''
                }`}>
                {btnTxt}
              </div>
            )}
            {rightImage && (
              <div className="et-v2-multi-state-btn-right-image-wrap">
                {rightImage}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default MultiStateButton;
